import React from "react";

interface EmailValidatedComponentProps {
  text: string;
  setText: (value: string) => void;
  className?: string;
}

const EmailValidatedComponent = ({
  text,
  setText,
  className,
}: EmailValidatedComponentProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setText(value);
    const isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/gm.test(value);
    e.target.setCustomValidity(isValid ? "" : "Please enter a valid email");
  };

  return (
    <input
      required
      type="email"
      placeholder="Email"
      className={className}
      value={text}
      onChange={handleChange}
    />
  );
};

export default EmailValidatedComponent;